import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthService} from "../services/auth-service/auth.service";
import {DataService} from "../services/data-service/data.service";


@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(private authService: AuthService,
              private router: Router,
              private dataService: DataService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.dataService.getValue('userId'); // Example of fetching from your updated service
    if (user) {
      // User is logged in
      return true;
    }

    // Redirect to login if not authenticated
    this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
